export const COMMON_CATEGORY_DATA = { category: 'common_cat', name: 'Общие требования к XML-файлам' };
